module.exports = ".full-width {\n  width: 100%;\n}\n\n.form-tipificacion {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 360px;\n}"